export const DashboardData =  {
    "currently_opened": [
        {
            "uuid" :  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "thumbnail" :"images/iconPlechovka.png",
            "name" : "Main Plechovka 1",
            "version" : "2",
            "last_edit" : "1629138571",
            "opened" : {
                "phone" : false,
                "photoshop" : true,
                "illustrator" : false
            }
        },
        {
            "uuid" :  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "thumbnail" : "images/iconPlechovka.png",
            "name" : "Main Plechovka 2",
            "version" : "3",
            "last_edit" : "1629138571",
            "opened" : {
                "phone" : false,
                "photoshop" : false,
                "illustrator" : true
            }
        },
        {
            "uuid" :  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "thumbnail" :"images/iconPlechovka.png",
            "name" : "Main Plechovka 3",
            "version" : "4",
            "last_edit" : "1629138571",
            "opened" : {
                "phone" : true,
                "photoshop" : false,
                "illustrator" : false
            }
        },
    ],
    "last_opened": [
        {
            "uuid" :  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "thumbnail" :"images/iconPlechovka.png",
            "name" : "Main Plechovka 2",
            "version" : "3",
            "last_edit" : "1629138571",
        },
        {
            "uuid" :  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "thumbnail" :"images/iconPlechovka.png",
            "name" : "Main Plechovka 3",
            "version" : "4",
            "last_edit" : "1629138571",
        },
    ]
};
export const DataProducts = [
    {
        "name" : "Main Plechovka 1",
        "uuid" :  "12345678-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "thumbnail" : "/images/clients/iconPlechovka.png",
        "groups" : {
            "client" :  "12345678-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "brand" : "12345678-1234-Mxxx-Nxxx-xxxxxxxxxxxx",
            "editions" : "12345678-1234-M123-Nxxx-xxxxxxxxxxxx",
        },
        "packages":{
            "type" :  "can",
            "size" : "150ml"
        },
        "versions" : [
            {
                "name" : "Plechovka 1",
                "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "thumbnail" :  "/images/clients/iconPlechovka.png",
                "version" : "1",
                "created" : {
                    "datetime" : "1629138571",
                    "user" : {
                        "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                        "full_name": "Vašek Ra",
                        "avatar": "/images/avatar.png"
                    }
                },
                "last_update" : {
                    "datetime" : "1629138571",
                    "user" : {
                        "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                        "full_name": "Vašek Ra",
                        "avatar": "/images/avatar.png"
                    }
                },
            },
            {
                "name" : "Plechovka 2",
                "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "thumbnail" :  "/images/clients/iconPlechovka.png",
                "version" : "2",
                "created" : {
                    "datetime" : "1629138571",
                    "user" : {
                        "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                        "full_name": "Vašek Ra",
                        "avatar": "/images/avatar.png"
                    }
                },
                "last_update" : {
                    "datetime" : "1629138571",
                    "user" : {
                        "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                        "full_name": "Vašek Ra",
                        "avatar": "/images/avatar.png"
                    }
                },
            }
        ],
        "users" :[
            {
                "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            }
        ]
    },
    {
        "name" : "Main Plechovka 2",
        "uuid" :  "xxxxxxxx-9234-Mxxx-Nxxx-xxxxxxxxxxxx",
        "thumbnail" : "/images/clients/iconPlechovka.png",
        "groups" : {
            "client" :  "12345678-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "brand" : "12345678-1234-Mxxx-Nxxx-xxxxxxxxxxxx",
            "editions" : "12345678-1234-M123-Nxxx-xxxxxxxxxxxx",
        },
        "packages":{
            "type" :  "can",
            "size" : "150ml"
        },
        "versions" : [
            {
                "name" : "Plechovka 2",
                "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "thumbnail" :  "/images/clients/iconPlechovka.png",
                "version" : "1",
                "created" : {
                    "datetime" : "1629138571",
                    "user" : {
                        "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                        "full_name": "Vašek Ra",
                        "avatar": "/images/avatar.png"
                    }
                },
                "last_update" : {
                    "datetime" : "1629138571",
                    "user" : {
                        "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                        "full_name": "Vašek Ra",
                        "avatar": "/images/avatar.png"
                    }
                },
            },
            {
                "name" : "Plechovka 2",
                "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "thumbnail" :  "/images/clients/iconPlechovka.png",
                "version" : "2",
                "created" : {
                    "datetime" : "1629138571",
                    "user" : {
                        "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                        "full_name": "Vašek Ra",
                        "avatar": "/images/avatar.png"
                    }
                },
                "last_update" : {
                    "datetime" : "1629138571",
                    "user" : {
                        "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                        "full_name": "Vašek Ra",
                        "avatar": "/images/avatar.png"
                    }
                },
            }
        ],
        "users" :[
            {
                "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            }
        ]
    },
    {
        "name" : "Main Plechovka 3",
        "uuid" :  "xxxxxxxx-xxxx-M8657-Nxxx-xxxxxxxxxxxx",
        "thumbnail" : "/images/clients/iconPlechovka.png",
        "groups" : {
            "client" :  "12345678-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "brand" : "12345678-1234-Mxxx-Nxxx-xxxxxxxxxxxx",
            "editions" : "12345678-1234-M123-Nxxx-xxxxxxxxxxxx",
        },
        "packages":{
            "type" :  "can",
            "size" : "150ml"
        },
        "versions" : [
            {
                "name" : "Plechovka 2",
                "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "thumbnail" :  "/images/clients/iconPlechovka.png",
                "version" : "1",
                "created" : {
                    "datetime" : "1629138571",
                    "user" : {
                        "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                        "full_name": "Vašek Ra",
                        "avatar": "/images/avatar.png"
                    }
                },
                "last_update" : {
                    "datetime" : "1629138571",
                    "user" : {
                        "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                        "full_name": "Vašek Ra",
                        "avatar": "/images/avatar.png"
                    }
                },
            },
            {
                "name" : "Plechovka 2",
                "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "thumbnail" :  "/images/clients/iconPlechovka.png",
                "version" : "2",
                "created" : {
                    "datetime" : "1629138571",
                    "user" : {
                        "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                        "full_name": "Vašek Ra",
                        "avatar": "/images/avatar.png"
                    }
                },
                "last_update" : {
                    "datetime" : "1629138571",
                    "user" : {
                        "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                        "full_name": "Vašek Ra",
                        "avatar": "/images/avatar.png"
                    }
                },
            }
        ],
        "users" :[
            {
                "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            }
        ]
    }
];
export const DataProductsFilters =  {
    "clients" : [
        {
            "uuid" :  "12345678-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "name" : "Heineken",
            "icon" : "/images/clients/heineken.png"
        },
        {
            "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "name" : "Nestlé",
            "icon" : "/images/clients/nestle.png"
        },
        {
            "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "name" : "Unilever",
            "icon" : "/images/clients/unilever.png"
        }
    ],
    "brands" : [
        {
            "uuid" :"12345678-1234-Mxxx-Nxxx-xxxxxxxxxxxx",
            "name" : "Krušovice",
            "icon" : "/images/clients/noimage.png",
            "client_uuid" : "12345678-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        },
        {
            "uuid" : "12345678-4321-Mxxx-Nxxx-xxxxxxxxxxxx",
            "name" : "Semtex",
            "icon" : "/images/clients/noimage.png",
            "client_uuid" : "12345678-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        },
        {
            "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "name" : "Budvar",
            "icon" : "/images/clients/noimage.png",
            "client_uuid" : "",
        }
    ],
    "editions" : [
        {
            "uuid" : "12345678-1234-M123-Nxxx-xxxxxxxxxxxx",
            "name" : "Hockey Edition 2021 CZ",
            "icon" :  "/images/clients/noimage.png",
            "brand_uuid" :"12345678-1234-Mxxx-Nxxx-xxxxxxxxxxxx",
        },
        {
            "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "name" : "Summer Edition 2021 CZ",
            "icon" :  "/images/clients/noimage.png",
            "brand_uuid" :"12345678-4321-Mxxx-Nxxx-xxxxxxxxxxxx",
        },
        {
            "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "name" : "New Edition 2022 CZ",
            "icon" :  "/images/clients/noimage.png",
            "brand_uuid" :"",
        }
    ],
    /// VYSKLADAT Z PRODUKTU
    "product_types" : [
        {
            "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "name" : "Cans",
            "icon" :  "/images/clients/noimage.png",
            "comming_soon" : "false"
        },
        {
            "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "name" : "Cartoons",
            "icon" :  "/images/clients/noimage.png",
            "comming_soon" : "false"
        }
    ],
    /// VYSKLADAT Z PRODUKTU
    "sizes" : [
        {
            "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "name" : "150ml",
            "icon" :  "/images/clients/noimage.png",
            "comming_soon" : "false"
        },
        {
            "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "name" : "250ml",
            "icon" :  "/images/clients/noimage.png",
            "comming_soon" : "false"
        },
        {
            "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "name" : "500ml",
            "icon" :  "/images/clients/noimage.png",
            "comming_soon" : "false"
        }
    ]
};
export const DataProductDetailWithVersions =
    [
        {
            "name" : "Main Plechovka 1",
            "uuid" :  "12345678-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "thumbnail" : "/images/clients/iconPlechovka.png",
            "groups" : {
                "client" :  "12345678-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "brand" : "12345678-1234-Mxxx-Nxxx-xxxxxxxxxxxx",
                "editions" : "12345678-1234-M123-Nxxx-xxxxxxxxxxxx",
            },
            "versions" : [
                {
                    "name" : "Plechovka 1",
                    "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                    "thumbnail" :  "/images/clients/iconPlechovka.png",
                    "version" : "1",
                    "created" : {
                        "datetime" : "1629138571",
                        "user" : {
                            "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                            "full_name": "Vašek Ra",
                            "avatar": "/images/avatar.png"
                        }
                    },
                    "last_update" : {
                        "datetime" : "1629138571",
                        "user" : {
                            "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                            "full_name": "Vašek Ra",
                            "avatar": "/images/avatar.png"
                        }
                    },
                },
                {
                    "name" : "Plechovka 2",
                    "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                    "thumbnail" :  "/images/clients/iconPlechovka.png",
                    "version" : "2",
                    "created" : {
                        "datetime" : "1629138571",
                        "user" : {
                            "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                            "full_name": "Vašek Ra",
                            "avatar": "/images/avatar.png"
                        }
                    },
                    "last_update" : {
                        "datetime" : "1629138571",
                        "user" : {
                            "uuid": "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                            "full_name": "Vašek Ra",
                            "avatar": "/images/avatar.png"
                        }
                    },
                }
            ]
        }
    ];
export const EditorData =
    {
        "product": {
            "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "name" : "Plechovka 1",
            "version" : "1",
            "master_product_uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
            "created" : {
                "datetime" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "user" : {
                    "uuid":  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                    "full_name": "Vašek Ra",
                    "avatar": "/images/clients/noimage.png"
                }
            },
            "last_update" : {
                "datetime" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "user" : {
                    "uuid":  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                    "full_name": "Vašek Ra",
                    "avatar": "/images/clients/noimage.png"
                }
            },
            "options" : {
                // "shell-color" "shellCernaColorUUID",
                // "tab-color": "shellCernaColorUUID",
                 "main-design": "TestMainDesign",
                "matte-design": "TestMatteDesign",
                // "fluorescent-design": "shellCernaColorUUID",
                // "thermo-design": "shellCernaColorUUID",
                // "incised-design": "shellCernaColorUUID",
                // "embossed-design": "shellCernaColorUUID",
                // "punched-design": "shellCernaColorUUID",
                // "lasered-design": "shellCernaColorUUID",
                //shellDefaultColorUUID
                // shellZlataColorUUID
                // shellCernaColorUUID
                // shellZlutaColorUUID
                // shellOranzovaColorUUID

                // DefaultMainDesign
                // DefaultMatteDesign
                // DefaultThermoDesign
                // DefaultFluorDesign
                // shellDefaultColorUUID
                // shellZlataColorUUID
                // DefaultEmbossedDesign
                // DefaultIncisedDesign
                // TestIncisedDesign
                // tabDefaultColorUUID
                // tabCernaColorUUID
                // DefaultLaseredDesign
                // DefaultPunchedDesign
                //
                "shell-color": "shellZlataColorUUID",
                "scene" :"12345678-1234-Mxxx-Nxxx-xxxxxxxxxxxx",
            },
            "package" : {
                "uuid" :  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "name" : "500ml Can Package",
                "models" : {
                    "ios" : "products/cans/bodies/standard/500ml/models/Can_Ardagh_standard_ALU_500_Body.usdz",
                    "android" : "products/cans/bodies/standard/500ml/models/Can_Ardagh_standard_ALU_500_Body.sfb",
                    "web" : "products/cans/bodies/standard/500ml/models/Can_Ardagh_standard_ALU_500_Body.fbx"
                }
            },
            "opening" : {
                "uuid" :  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "name" : "Default Can Opening",
                "models" : {
                    "ios" : "products/cans/openings/standard/models/Can_Ardagh_standard_ALU_500_Opening.usdz",
                    "android" : "products/cans/openings/standard/models/Can_Ardagh_standard_ALU_500_Opening_CAP.sfb",
                    "androidshell" : "products/cans/openings/standard/models/Can_Ardagh_standard_ALU_500_Opening_CAP.sfb",
                    "androidtab" : "products/cans/openings/standard/models/Can_Ardagh_standard_ALU_500_Opening_CAP_OPENER_HOLE.sfb",
                    "androidtabfull" : "products/cans/openings/standard/models/Can_Ardagh_standard_ALU_500_Opening_CAP_OPENER_FULL.sfb",
                    "web" : "products/cans/openings/standard/models/Can_Ardagh_standard_ALU_500_Opening.fbx"
                },
                "offset" : {
                    "x" : "0",
                    "y" : "0",
                    "z" : "10.5"
                }
            },
        },
        "actions" : [
            {
                "name": "Body",
                "icon": "/images/bodycan.png",
                "key" : "body",
                "actions" : [
                    {
                        "name": "Main Design",
                        "key": "main-design",
                        "type" : "texture",
                        "icon": "/images/maindesigncan.png",
                        //       "default_value": "(string|uuid|integer|bool|object|null)",
                        "default_value":   "DefaultMainDesign",
                        "values" : [
                            {
                                "uuid" :  "DefaultMainDesign",
                                "name" : "Obalero",
                                "value" : "users/products/product1_500ml/version1/textures/BodyMainDesign.jpg",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" :  "TestMainDesign",
                                "name" : "Custom",
                                "value" : "products/cans/bodies/standard/500ml/textures/krusovice.jpg",
                                "thumbnail" : "/images/designthumb.png"
                            }
                        ]
                    },
                    {
                        "name": "Matte Design",
                        "key": "matte-design",
                        "type" : "bool",
                        "icon": "/images/mattedesigncan.png",
                        "default_value":  "OffMatteDesign",
                        "values" : [
                            {
                                "uuid" :  "OffMatteDesign",
                                "name" : "Off",
                                "value" : "true",
                                "thumbnail" : "/images/icons/ban-solid.svg"
                            },
                            {
                                "uuid" :  "TestMatteDesign",
                                "name" : "On",
                                "value" : "false",
                                "thumbnail" : "/images/icons/power-off-solid.svg"
                            }
                        ]
                    },
                    {
                        "name": "Thermo Impact Design",
                        "key": "thermo-design",
                        "type" : "texture",
                        "icon": "/images/thermoiconcan.png",
                        "default_value":   "OffThermoDesign",
                        "values" : [
                            {
                                "uuid" :  "OffThermoDesign",
                                "name" : "Off",
                                "value" : "null",
                                "thumbnail" : "/images/icons/ban-solid.svg"
                            },
                            {
                                "uuid" :  "TestThermoDesign",
                                "name" : "Obalero",
                                "value" : "users/products/product1_500ml/version1/textures/BodyThermoDesign.jpg",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" :  "TestThermoDesignCustom",
                                "name" : "Custom",
                                "value" : "products/cans/bodies/standard/500ml/textures/thermo.jpg",
                                "thumbnail" : "/images/designthumb.png"
                            }
                        ]
                    },
                    {
                        "name": "Fluorescent Impact Design",
                        "key": "fluorescent-design",
                        "type" : "texture",
                        "icon": "/images/fluorescenticoncan.png",
                        "default_value":    "OffFluorDesign",
                        "values" : [
                            {
                                "uuid" :  "OffFluorDesign",
                                "name" : "Off",
                                "value" : "null",
                                "thumbnail" : "/images/icons/ban-solid.svg"
                            },
                            {
                                "uuid" :  "DefaultFluorDesign",
                                "name" : "Obalero",
                                "value" : "users/products/product1_500ml/version1/textures/BodyFluoDesign.jpg",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" :  "TestFluorDesign",
                                "name" : "Custom",
                                "value" : "products/cans/bodies/standard/500ml/textures/fluo.jpg",
                                "thumbnail" : "/images/designthumb.png"
                            }
                        ]
                    },
                ]
            },

            /////
            {
                "name": "Shells",
                "icon": "/images/shells.png",
                "key" : "shell",
                "actions" : [
                    {
                        "name": "Color",
                        "key": "shell-color",
                        "type" : "color",
                        "icon": "/images/designthumb.png",
                        "default_value":   "shellDefaultColorUUID",
                        "values" : [
                            {
                                "uuid" :  "shellDefaultColorUUID",
                                "name" : "Default Color: d7d7d7",
                                "value" : "d7d7d7",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" :  "shellZlataColorUUID",
                                "name" : "Color: ffd700",
                                "value" : "ffd700",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" :  "shellCernaColorUUID",
                                "name" : "Color: 000000",
                                "value" : "000000",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" :  "shellZlutaColorUUID",
                                "name" : "Color: ffff00",
                                "value" : "ffff00",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" :  "shellOranzovaColorUUID",
                                "name" : "Color: ffa500",
                                "value" : "ffa500",
                                "thumbnail" : "/images/designthumb.png"
                            }
                        ]
                    },
                    {
                        "name": "Embossed Design",
                        "key": "embossed-design",
                        "type" : "texture",
                        "icon": "/images/designthumb.png",
                        "default_value":    "OffEmbossedDesign",
                        "values" : [
                            {
                                "uuid" : "OffEmbossedDesign",
                                "name" : "Off",
                                "value" : "null",
                                "thumbnail" : "/images/icons/ban-solid.svg"
                            },
                            {
                                "uuid" :   "TestEmbossedDesign",
                                "name" : "Original",
                                "value" : "users/products/product1_500ml/version1/textures/ShellEmbossedDesign.jpg",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" :   "Custom EmbossedDesign",
                                "name" : "Custom",
                                "value" : "users/products/product1_500ml/version1/textures/ShellEmbossedDesign.jpg",
                                "thumbnail" : "/images/designthumb.png"
                            }
                        ]
                    },
                    {
                        "name": "Incised  Design",
                        "key": "incised-design",
                        "type" : "texture",
                        "icon": "/images/designthumb.png",
                        "default_value":    "OffIncisedDesign",
                        "values" : [
                            {
                                "uuid" : "OffIncisedDesign",
                                "name" : "Off",
                                "value" : "null",
                                "thumbnail" : "/images/icons/ban-solid.svg"
                            },
                            {
                                "uuid" :   "TestIncisedDesign",
                                "name" : "Original",
                                "value" : "users/products/product1_500ml/version1/textures/ShellIncisedDesign.jpg",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" :   "CustomIncisedDesign",
                                "name" : "Custom",
                                "value" : "users/products/product1_500ml/version1/textures/ShellIncisedDesign.jpg",
                                "thumbnail" : "/images/designthumb.png"
                            }
                        ]
                    }
                ]
            },

            //////////
            {
                "name": "Tabs",
                "icon": "/images/tabs.png",
                "key" : "tabs",
                "actions" : [
                    {
                        "name": "Color",
                        "key": "tabs-color",
                        "type" : "color",
                        "icon": "/images/designthumb.png",
                        "default_value":  "tabDefaultColorUUID",
                        "values" : [
                            {
                                "uuid" :  "tabDefaultColorUUID",
                                "name" : "Default Color: d7d7d7",
                                "value" : "d7d7d7",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" : "tabZlataColorUUID",
                                "name" : "Color: ffd700",
                                "value" : "ffd700",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" :   "tabCernaColorUUID",
                                "name" : "Color: 000000",
                                "value" : "000000",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" : "tabZlutaColorUUID",
                                "name" : "Color: ffff00",
                                "value" : "ffff00",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" :  "tabOranzovaColorUUID",
                                "name" : "Color: ffa500",
                                "value" : "ffa500",
                                "thumbnail" : "/images/designthumb.png"
                            }
                        ]
                    },
                    {
                        "name": "Lasered Design",
                        "key": "lasered-design",
                        "type" : "texture",
                        "icon": "/images/designthumb.png",
                        "default_value":    "OffLaseredDesign",
                        "values" : [
                            {
                                "uuid" : "OffLaseredDesign",
                                "name" : "Off",
                                "value" : "null",
                                "thumbnail" : "/images/icons/ban-solid.svg"
                            },
                            {
                                "uuid" :   "TestLaseredDesign",
                                "name" : "Original",
                                "value" : "users/products/product1_500ml/version1/textures/TabLaseredDesign.jpg",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" :   "CustomLaseredDesign",
                                "name" : "Custom",
                                "value" : "users/products/product1_500ml/version1/textures/TabLaseredDesign.jpg",
                                "thumbnail" : "/images/designthumb.png"
                            }
                        ]
                    },
                    {
                        "name": "Punched Design",
                        "key": "punched-design",
                        "type" : "texture",
                        "icon": "/images/designthumb.png",
                        "default_value":   "OffPunchedDesign",
                        "values" : [
                            {
                                "uuid" : "OffPunchedDesign",
                                "name" : "Off",
                                "value" : "null",
                                "thumbnail" : "/images/icons/ban-solid.svg"
                            },
                            {
                                "uuid" :   "TestPunchedDesign",
                                "name" : "Original",
                                "value" : "users/products/product1_500ml/version1/textures/TabPunchedDesign.jpg",
                                "thumbnail" : "/images/designthumb.png"
                            },
                            {
                                "uuid" :   "CustomPunchedDesign",
                                "name" : "Custom",
                                "value" : "users/products/product1_500ml/version1/textures/TabPunchedDesign.jpg",
                                "thumbnail" : "/images/designthumb.png"
                            }
                        ]
                    }
                ]
            }
        ],
        "scenes" : [
            {
                "uuid" :  "12345678-1234-Mxxx-Nxxx-xxxxxxxxxxxx",
                "name" : "Default HDR",
                "key" : "default-hdr",
                "value" : "default",
                "type" : "HDR",
                "thumbnail" :  "/images/designthumb.png",
                "description" : "Default Editor HDR"
            },
            {
                "uuid" :  "12345678-4321-Mxxx-Nxxx-xxxxxxxxxxxx",
                "name" : "Bar HDR",
                "key" : "bar",
                "value" : "bar",
                "type" : "HDR",
                "thumbnail" :  "/images/designthumb.png",
                "description" : "Bar Editor HDR"
            },
            {
                "uuid" :  "12345678-1234-M123-Nxxx-xxxxxxxxxxxx",
                "name" : "Kitchen HDR",
                "value" : "kitchen",
                "file" : "/textures/enviroment/kitchen.hdr",
                "type" : "HDR",
                "thumbnail" :  "/images/designthumb.png",
                "description" : "Kitchen Editor HDR"
            },
            {
                "uuid" :  "12345678-1234-M123-Nx32-xxxxxxxxxxxx",
                "name" : "Field HDR",
                "value" : "field",
                "file" : "/textures/enviroment/kitchen.hdr",
                "type" : "HDR",
                "thumbnail" :  "/images/designthumb.png",
                "description" : "Filed Editor HDR"
            }
        ],
        "mode" : "edit",
        "share" : {
            "presentation" :
                {
                    "uuid" :  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                },
            "autocomplete" : [
                {
                    "uuid":  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                    "full_name": "(string)",
                    "email": "(string|null)",
                    "avatar": "(string)"
                }
            ],

            "users" : [
                {
                    "uuid":  "12345678-9425-Mxxx-Nxxx-xxxxxxxxxxxx",
                    "full_name": "Vašek",
                    "email": "vaclav.strobl@mfcc.cz",
                    "avatar": "/images/avatar.png",
                    "role" : "admin",
                    "status" : "active",
                    "created" : {
                        "datetime" : "(timestamp)"
                    },
                },
                {
                    "uuid":  "12345678-9425-Mxxx-Nxxx-xxxxxxxxxxxx",
                    "full_name": "Maxim",
                    "email": "maxim@mfcc.cz",
                    "avatar": "/images/avatar.png",
                    "role" : "commentator",
                    "status" : "active",
                    "created" : {
                        "datetime" : "(timestamp)"
                    },
                },
                {
                    "uuid":  "12345678-9425-Mxxx-Nxxx-xxxxxxxxxxxx",
                    "full_name": "Pepa",
                    "email": "pepa@mfcc.cz",
                    "avatar": "/images/avatar.png",
                    "role" : "viewer",
                    "status" : "active",
                    "created" : {
                        "datetime" : "(timestamp)"
                    },
                }
            ],
        },
        "download_links" : {
            "illustrator" : "/models/Cans/Ardagh/Bodies/Standard/500ml/ps.psd",
            "photoshop" :  "/models/Cans/Ardagh/Bodies/Standard/500ml/ps.psd",
        },
        "breadcrumbs" : [
            {
                "uuid" :  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "name" : "Heineken"
            },
            {
                "uuid" :  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "name" : "Krušovice"
            },
            {
                "uuid" :  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "name" : "Summer Edition"
            },
            {
                "uuid" :  "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
                "name" : "Plechovka 1"
            }
        ]
    }

    //////////////// TODO

export const NewProductData =
[
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Cans",
        "thumbnail" : "/images/iconPlechovka.png",
        "comming_soon" : false,
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Tetrapacks",
        "thumbnail" : "/images/tetrapak/tetra_brik_off.png",
        "comming_soon" : false,
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Bottles",
        "thumbnail" : "/images/bottle.png",
        "comming_soon" : true,
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Boxes",
        "thumbnail" : "/images/boxes.png",
        "comming_soon" : true,
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Custom",
        "thumbnail" : "/images/customShape.png",
        "comming_soon" : true,
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Plastic",
        "thumbnail" : "/images/plastic.png",
        "comming_soon" : true,
    }
];
export const NewProductDetailData =
[
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Slim 150ml",
        "id" : "can-slim-150ml",
        "size" : "150ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Slim",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Slim 200ml",
        "id" : "can-slim-200ml",
        "size" : "200ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Slim",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Slim 250ml",
        "id" : "can-slim-250ml",
        "size" : "250ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Slim",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Slim 330ml",
        "id" : "can-slim-330ml",
        "size" : "330ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Slim",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Slim 355ml",
        "id" : "can-slim-355ml",
        "size" : "355ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Slim",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Slim 375ml",
        "id" : "can-slim-375ml",
        "size" : "375ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Slim",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Slim 440ml",
        "id" : "can-slim-440ml",
        "size" : "440ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Slim",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Slim 470ml",
        "id" : "can-slim-470ml",
        "size" : "470ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Slim",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Slim 500ml",
        "id" : "can-slim-500ml",
        "size" : "500ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Slim",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Slim 530ml",
        "id" : "can-slim-530ml",
        "size" : "530ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Slim",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Slim 550ml",
        "id" : "can-slim-550ml",
        "size" : "550ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Slim",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Slim 568ml",
        "id" : "can-slim-568ml",
        "size" : "568ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Slim",
            "type" : "Cans"
        }
    },

    //////////// SLEE
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Sleek 150ml",
        "id" : "can-sleek-150ml",
        "size" : "150ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Sleek",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Sleek 200ml",
        "id" : "can-sleek-200ml",
        "size" : "200ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Sleek",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Sleek 250ml",
        "id" : "can-sleek-250ml",
        "size" : "250ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Sleek",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Sleek 330ml",
        "id" : "can-sleek-330ml",
        "size" : "330ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Sleek",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Sleek 355ml",
        "id" : "can-sleek-355ml",
        "size" : "355ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Sleek",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Sleek 375ml",
        "id" : "can-sleek-375ml",
        "size" : "375ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Sleek",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Sleek 440ml",
        "id" : "can-sleek-440ml",
        "size" : "440ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Sleek",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Sleek 470ml",
        "id" : "can-sleek-470ml",
        "size" : "470ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Sleek",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Sleek 500ml",
        "id" : "can-sleek-500ml",
        "size" : "500ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Sleek",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Sleek 530ml",
        "id" : "can-sleek-530ml",
        "size" : "530ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Sleek",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Sleek 550ml",
        "id" : "can-sleek-550ml",
        "size" : "550ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Sleek",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Sleek 568ml",
        "id" : "can-sleek-568ml",
        "size" : "568ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Sleek",
            "type" : "Cans"
        }
    },

    //////////// Standard
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Standard 150ml",
        "id" : "can-standard-150ml",
        "size" : "150ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Standard",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Standard 200ml",
        "id" : "can-standard-200ml",
        "size" : "200ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Standard",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Standard 250ml",
        "id" : "can-standard-250ml",
        "size" : "250ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Standard",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Standard 330ml",
        "id" : "can-standard-330ml",
        "size" : "330ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Standard",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Standard 355ml",
        "id" : "can-standard-355ml",
        "size" : "355ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : false,
        "description" : "neconeco",
        "group" : {
            "name" : "Standard",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Standard 375ml",
        "id" : "can-standard-375ml",
        "size" : "375ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Standard",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Standard 440ml",
        "id" : "can-standard-440ml",
        "size" : "440ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Standard",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Standard 470ml",
        "id" : "can-standard-470ml",
        "size" : "470ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Standard",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Standard 500ml",
        "id" : "can-standard-500ml",
        "size" : "500ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Standard",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Standard 530ml",
        "id" : "can-standard-530ml",
        "size" : "530ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Standard",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Standard 550ml",
        "id" : "can-standard-550ml",
        "size" : "550ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Standard",
            "type" : "Cans"
        }
    },
    {
        "uuid" : "xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx",
        "name" : "Can Standard 568ml",
        "id" : "can-standard-568ml",
        "size" : "568ml",
        "thumbnail" : "/images/iconPlechovka.png",
        "active" : true,
        "description" : "neconeco",
        "group" : {
            "name" : "Standard",
            "type" : "Cans"
        }
    }


]